export const AdSetBudgetIncreasedIcon = ({ className, size = 27, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M15.5 5.5L21.5 5.5" stroke="#4DD15E" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M18.5 2.5L18.5 8.5" stroke="#4DD15E" strokeWidth="1.5" strokeLinecap="round" />
        <path
            d="M17.9373 12.0958C17.9172 13.7652 17.3753 15.3864 16.3876 16.7324C15.3999 18.0784 14.0158 19.0816 12.4294 19.6015C10.8429 20.1215 9.13352 20.1321 7.54074 19.6318C5.94796 19.1316 4.55158 18.1456 3.54727 16.812C2.54296 15.4783 1.98104 13.8639 1.94024 12.1949C1.89944 10.5259 2.38181 8.886 3.31975 7.50489C4.2577 6.12379 5.60422 5.07072 7.17066 4.49324C8.73709 3.91577 10.4449 3.84282 12.0549 4.28462"
            stroke="#4DD15E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.4149 10.0106C12.4149 9.07447 11.4787 7.90426 10.0745 7.90426M10.0745 7.90426C8.67021 7.90426 7.5 8.84043 7.5 10.0106C7.5 11.1809 8.20213 12.117 10.0745 12.117C11.9468 12.117 12.4149 13.0532 12.4149 14.2234C12.4149 15.3936 11.2447 16.3298 9.84043 16.3298M10.0745 7.90426V6.5M7.5 14.2234C7.5 15.1596 8.43617 16.3298 9.84043 16.3298M9.84043 16.3298V17.5"
            stroke="#4DD15E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default AdSetBudgetIncreasedIcon
